import React from "react";

import { localizer } from "../../Translator"

import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import Paper from '@material-ui/core/Paper';
import { Grid } from "@material-ui/core";
import Container from '@material-ui/core/Container'
import { Backdrop, CircularProgress } from "@material-ui/core"
import { Typography } from "@material-ui/core";
import { Button } from "@material-ui/core";
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText'
import Pagination from '@material-ui/lab/Pagination'
import PaginationItem from '@material-ui/lab/PaginationItem'

import { GridHeaderFilter } from '../common/HeaderComponentStyled.js'
import { TableRowHeaderStyled, TableRowStyled, TableCellStyled } from '../common/TableStyled.js'
import { TableStyled } from '../common/TableStyled.js'
import ScreenHeading from "../common/ScreenHeading.js";

import { SnackbarCustom } from "../Utilities/SnackbarCustom";
import DateCustom from "../Utilities/DateCustom";
import CurrencyCustom from '../Utilities/CurrencyCustom.js';

import { FeedbackRow } from "./sections/FeedbackRow";

import AuthCli from "../../sdk/AuthCli.js";
import InboxCli from "../../sdk/InboxCli.js";
import ProductCli from "../../sdk/ProductCli.js";
import Roles from "../Utilities/Roles.js";
import ReportCli from "../../sdk/ReportCli.js";

const FEEDBACK_PAGE_SIZE = 50
const FEEDBACK_PAGE_SIZE_OPTIONS = [50, 100]

const showItems = [{ "id": "showStates", "name": localizer.InboxShowStates  },
  { "id": "showProofs", "name": localizer.InboxShowProofs },
  { "id": "showCerts", "name": localizer.InboxShowCerts },
  { "id": "showDocuments", "name": localizer.InboxShowDocuments },
  { "id": "showStampedCopy", "name": localizer.InboxShowStampedCopy },
]
const INITAL_FILTERS = {
  showStates: true,
  showProofs: true,
  showCerts: true,
  showDocuments: true,
  showStampedCopy: true,
  showReports: true,
  shipmentCode: null,
  Since: null,
  Until: null
}

export class InboxLayout extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      
      // User session info
      session: null,

      // Total of feedbacks read and unread of the user/cliente
      feedbacks: [],

      // List of products availables for the user in session
      products: [],

      // Flag to determinate if more feedbacks can be loaded
      endOfFeedbacks: false,

      // Number of paged already loaded
      pagesLoaded: 0,
      pageSize: FEEDBACK_PAGE_SIZE,
      totalFeedbacks: 0,

      // String errors to display in case of service calls go wrong
      feedbackError: null,
      feedbackCountError: null,
      feedbackReadAllError: null,
      feedbackReadAllSuccess: null,
      errormessage: null,
      
      // Number of feedbacks unread for the title
      countUnreadFeedbacks: 0,

      // List of feedback selected by user/client
      feedbacksIdsSelected: [],
      checkedAll: false,

      // Dinamic name of the action button to read/unread feedbacks
      buttonMark: "",

      // Filters
      filters: INITAL_FILTERS,
      stateReadChanged: false,

      //selected option to show feedback´s  type
      showItemsSelected: showItems,
      
      //to snackbar
      severity: "info",
      message: null,
    }
  }

  /**
   *  Component initialization. Loading first page of feedbacks and unread
   */
  async componentDidMount() {
    await AuthCli.GetSessionInfo().then(session => {
      if (session) {
        this.setState({ session: session }, () => {
          //this.getAvailableProductsForUser()
          this.getAllProducts()

          if (this.state.session.role === Roles.ROLE_USER.Name) {
            this.getFeedback()
            return
          }

          if (this.state.session.role === Roles.ROLE_ADMIN.Name || this.state.session.role === Roles.ROLE_SUPERVISOR.Name) {
            this.getFeedbackOfBillable()
            return
          }
        })
      }
    })
  }

  /**
   * Realoding list of feedbacks and unread in case filters change
   */
  componentDidUpdate(previousProps, previousState) {

    if (previousState.filters.showStates !== this.state.filters.showStates ||
      previousState.filters.showProofs !== this.state.filters.showProofs ||
      previousState.filters.showCerts !== this.state.filters.showCerts ||
      previousState.filters.showDocuments !== this.state.filters.showDocuments ||
      previousState.filters.showStampedCopy !== this.state.filters.showStampedCopy ||
      previousState.filters.showReports !== this.state.filters.showReports ||
      previousState.stateReadChanged !== this.state.stateReadChanged) {
      
      this.setState({ isLoading: true, pagesLoaded: 0 }, () => {
        if (this.state.session.role === Roles.ROLE_USER.Name) {
          this.getFeedback(true)
          return
        }

        if (this.state.session.role === Roles.ROLE_ADMIN.Name || this.state.session.role === Roles.ROLE_SUPERVISOR.Name) {
          this.getFeedbackOfBillable(true)
          return
        }
      })
    }
  }

  getFeedback = (isFiltered, filters) => {
    if (!filters) filters = this.state.filters

    this.setState({ isLoading: true })

    InboxCli.GetFeedback(this.state.pageSize,
      this.state.pagesLoaded,
      true,
      filters.showStates,
      filters.showProofs,
      filters.showCerts,
      filters.showDocuments,
      filters.showReports,
      filters.showStampedCopy).then(data => {
        if (data !== null && data.toString().startsWith("[ERR")) {
          this.setState({ feedbackError: data.substring(data.indexOf(' ')) })
        } else {
          if (data.length > 0) {
            let feedbackids = data.map(s => { return s.returnId })
            let feedbacksIdsSelected = this.state.checkedAll ? this.state.feedbacksIdsSelected.concat(feedbackids) : this.state.feedbacksIdsSelected
            
            this.setState({
              feedbacks: data,
              feedbacksIdsSelected: feedbacksIdsSelected,
              shipmentsError: null
            })
          } else {
            this.setState({ feedbacks: data, feedbacksIdsSelected: [] })
          }
          
          if (data.length < FEEDBACK_PAGE_SIZE) {
            this.setState({ endOfFeedbacks: true, feedbackError: null })
          }
        }

        this.getFeedbackCount(filters)
          
        this.setState({ isLoading: false })
      })
  }

  getFeedbackOfBillable = (isFiltered, filters) => {
    if (!filters) filters = this.state.filters

    this.setState({ isLoading: true })
    
    InboxCli.GetFeedbackOfBillable(this.state.pageSize,
      this.state.pagesLoaded,
      true,
      filters.showStates,
      filters.showProofs,
      filters.showCerts,
      filters.showDocuments,
      filters.showReports,
      filters.showStampedCopy).then(data => {

        if (data !== null && data.toString().startsWith("[ERR")) {
          this.setState({ feedbackError: data.substring(data.indexOf(' ')) })
        } else {
          if (data.length > 0) {
            let feedbackids = data.map(s => { return s.returnId })
            let feedbacksIdsSelected = this.state.checkedAll ? this.state.feedbacksIdsSelected.concat(feedbackids) : this.state.feedbacksIdsSelected
            
            this.setState({
              feedbacks: data,
              feedbacksIdsSelected: feedbacksIdsSelected,
              shipmentsError: null
            })
          } else {
            this.setState({ feedbacks: data, feedbacksIdsSelected: [] })
          }

          if (data.length < FEEDBACK_PAGE_SIZE) {
            this.setState({ endOfFeedbacks: true, feedbackError: null })
          } else {
            this.setState({ endOfFeedbacks: false, feedbackError: null })
          }
        }

        this.getFeedbackCount(filters)
          
        this.setState({ isLoading: false })
      })
  }

  getFeedbackCount = (filters) => {
    const countFeedback = this.state.session.role === Roles.ROLE_USER.Name
      ? (...argumentsList) => InboxCli.CountFeedback(...argumentsList)
      : (...argumentsList) => InboxCli.CountFeedbackOfBillable(...argumentsList)

    Promise.all([
      countFeedback(false, filters.showStates, filters.showProofs, filters.showCerts, filters.showDocuments, filters.showReports, filters.showStampedCopy),
      countFeedback(true, filters.showStates, filters.showProofs, filters.showCerts, filters.showDocuments, filters.showReports, filters.showStampedCopy)
    ]).then(([unreadCount, totalCount]) => {
      if ([unreadCount, totalCount].some(data => data !== null && data.toString().startsWith("[ERR"))) {
        const error = [unreadCount, totalCount].find(data => data !== null && data.toString().startsWith("[ERR"))
        this.setState({ feedbackCountError: error.substring(error.indexOf(' ')) })
        return
      }

      const totalFeedbacks = Number(totalCount)
      this.setState({
        countUnreadFeedbacks: unreadCount,
        totalFeedbacks: Number.isFinite(totalFeedbacks) && totalFeedbacks >= 0 ? totalFeedbacks : 0,
        feedbackCountError: null
      })
    })
  }

  loadFeedbackByRole = () => {
    if (this.state.session.role === Roles.ROLE_USER.Name) {
      this.getFeedback()
      return
    }

    if (this.state.session.role === Roles.ROLE_ADMIN.Name || this.state.session.role === Roles.ROLE_SUPERVISOR.Name) {
      this.getFeedbackOfBillable()
      return
    }
  }

  getMaxPageFromCount = () => {
    const total = Number(this.state.totalFeedbacks || 0)
    const pageSize = Number(this.state.pageSize || FEEDBACK_PAGE_SIZE)
    if (total <= 0 || pageSize <= 0) return 0

    return Math.max(Math.ceil(total / pageSize) - 1, 0)
  }

  handleChangePage = (newPage) => {
    const maxPage = this.getMaxPageFromCount()
    if (newPage < 0 || newPage > maxPage) return

    this.setState({
      pagesLoaded: newPage,
      checkedAll: true,
      feedbacksIdsSelected: []
    }, this.loadFeedbackByRole)
  }

  handleChangeRowsPerPage = (event) => {
    const newPageSize = parseInt(event.target.value, 10)
    this.setState({
      pageSize: Number.isFinite(newPageSize) ? newPageSize : FEEDBACK_PAGE_SIZE,
      pagesLoaded: 0,
      checkedAll: true,
      feedbacksIdsSelected: []
    }, this.loadFeedbackByRole)
  }
 
  // Getting list of products
  getAllProducts = async () => {
    ProductCli.GetAllProducts().then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ errormessage: response.substring(response.indexOf(' ')) })
      } else {
        this.setState({ products: response })
      }
    })
  }

  /**
   * Reading/Unreading feedbacks based in feedback selected by user/client
   * @returns 
   */
  checkFeedbacksAsReadOrUnread = () => {

    let feedbacks = [...this.state.feedbacks]
    let feedbackIdsSelected = [...this.state.feedbacksIdsSelected]

    if (feedbacks.length === 0) return

    // It means user want to read all returns
    if (this.state.feedbacksIdsSelected.length === 0) {
      InboxCli.ReadFeedback(feedbacks.map(fb => fb.returnId)).then(data => {
        if (data !== null && data.toString().startsWith("[ERR")) {
          this.setState({ message: data.substring(data.indexOf(' ')), severity: "error", })
        } else {
          this.setState({
            message: localizer.InboxReadAllSuccess, severity: "success",
            stateReadChanged: !this.state.stateReadChanged,
            feedbacksIdsSelected: [],
            checkedAll: false
          })
        }
      })
      return
    }
    
    let feedbacksToUnread = this.state.feedbacks.filter(f => feedbackIdsSelected.includes(f.returnId))

    // It means all returns selected are already read, so user want to mark them as unread
    if (feedbacksToUnread.length === feedbacksToUnread.filter(f => f.read).length) {
      InboxCli.UnreadFeedback(feedbackIdsSelected).then(data => {
        if (data !== null && data.toString().startsWith("[ERR")) {
          this.setState({ message: data.substring(data.indexOf(' ')), severity: "error" })
        } else {
          this.setState({
            message: localizer.InboxUnReadAllSuccess, severity: "success",
            stateReadChanged: !this.state.stateReadChanged,
            feedbacksIdsSelected: [],
            checkedAll: false
          })
          
        }
      })
      return
    }
    // Otherwise returns selected will be marked as read
    InboxCli.ReadFeedback(feedbackIdsSelected).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ message: data.substring(data.indexOf(' ')), severity: "error" })
      } else {
        this.setState({
          message: localizer.InboxReadAllSuccess, severity: "success",
          stateReadChanged: !this.state.stateReadChanged,
          feedbacksIdsSelected: [],
          checkedAll: false
        })
      }
    })
    return
  }

  /**
   * Adding/Removing feedback to feedbacks selected list when row checkbox is checked/unchecked
   * @param {*} returnId Id of the feedback to add/remove
   * @param {*} option CHECKED/UNCHECKED option to determinate if the action to apply is add or remove
   */
  addOrRemoveSelectedFeedbacks = (returnId, option) => {
    let feedbacksIdsSelected = [...this.state.feedbacksIdsSelected]
    if (option === 'CHECKED') {
      feedbacksIdsSelected.push(returnId)
    } else {
      feedbacksIdsSelected = feedbacksIdsSelected.filter(id => id !== returnId)
    }

    let buttonMark = localizer.InboxCheckAllAsRead
    let idsSelected = feedbacksIdsSelected
    if (idsSelected.length !== 0) {
      var feedbacksToUnread = this.state.feedbacks.filter(f => idsSelected.includes(f.returnId))
      buttonMark = feedbacksToUnread.length === feedbacksToUnread.filter(f => f.read).length ? localizer.InboxCheckSelectedAsUnread : localizer.InboxCheckSelectedAsRead
    }
    this.setState({ feedbacksIdsSelected: feedbacksIdsSelected, buttonMark: buttonMark })
  }

  /**
   * Switch element onChange event
   * @param {*} event 
   */
  handleChangeFilter = (event) => {
    this.setState(previousState => ({
      filters: {
        ...previousState.filters,
        [event.target.name]: event.target.checked
      }
    }))
  }

  /**
   * to Close snackbar, clean variables
   */
  handleonClose = () => {
    this.setState({
      feedbackError: null, feedbackCountError: null,
      message: null
    })
  }


  /**
   * initialize buttonmark text  
   * if it is initialized in componentDidMount doesn't get the correct language
  */
  initializeButtonMark = () => {
    var buttonMark = this.state.buttonMark

    if (!buttonMark) { buttonMark = localizer.InboxCheckAllAsRead }

    return buttonMark
  }

  /**
   * checked or unchecked of items to show
   */
  handleFieldChange = (event) => {
    let valChecked = event.currentTarget.dataset.modal
    var item = showItems.filter(s => s.id === valChecked)
    let checked = this.state.showItemsSelected.includes(item[0])
    let showItemsSelected = this.state.showItemsSelected
    
    if (checked) {
      showItemsSelected = this.state.showItemsSelected.filter(s => s.id !== valChecked)
    } else {
      showItemsSelected.push(item[0])
    }
     
    this.setState({ showItemsSelected: showItemsSelected })
    this.setState(previousState => ({
      filters: {
        ...previousState.filters,
        [valChecked]: !checked
      }
    }))
    
  }
  /**
   * Handle onChange event to update the state for inputs. 
   */
  onInputchange = (event) => {
    var inputName = event.target.name
    var inputValue = event.target.value
    var inputType = event.currentTarget.type

    if (!inputValue) {
      inputValue = null
    }
    
    if (inputType === "date" && inputValue !== null) {
      var dateUtc = DateCustom.convertToUtcDateTime(inputValue)
      
      this.setState(previousState => ({
        filters: {
          ...previousState.filters,
          [inputName]: dateUtc
        },
      })
      )
    } else {
      this.setState(previousState => ({
        filters: {
          ...previousState.filters,
          [inputName]: inputValue
        },
      })
      )
    }
  }

  doFilter = () => {

    let filters = { ...this.state.filters }
        
    if (filters.Since && filters.Until && filters.Since === filters.Until) {
      let dateTime = new Date(filters.Until)
      dateTime.setDate(dateTime.getDate() + 1)
      dateTime.setMinutes(dateTime.getMinutes() - 1)
      filters.Until = dateTime
    }
    //tendré que pasarle el filtro aquí
    this.setState({ isLoading: true, pagesLoaded: 0 }, () => {
      if (this.state.session.role === Roles.ROLE_USER.Name) {
        this.getFeedback(true)
        return
      }

      if (this.state.session.role === Roles.ROLE_ADMIN.Name || this.state.session.role === Roles.ROLE_SUPERVISOR.Name) {
        this.getFeedbackOfBillable(true)
        return
      }
    })
  }

  doCleanFilters = () => {
    this.setState({ filters: INITAL_FILTERS, pagesLoaded: 0, isLoading: true }, () => {
      if (this.state.session.role === Roles.ROLE_USER.Name) {
        this.getFeedback(true)
        return
      }

      if (this.state.session.role === Roles.ROLE_ADMIN.Name || this.state.session.role === Roles.ROLE_SUPERVISOR.Name) {
        this.getFeedbackOfBillable(true)
        return
      }
    })
  }

  /** Adds or removes all feedbackids selected list */
  onChangeSelectAll = (event) => {
    this.setState({ [event.target.name]: event.target.checked }, () => {
      let feedbacksIdsSelected = []
      if (this.state.checkedAll) feedbacksIdsSelected = this.state.feedbacks.map(f => { return f.returnId })
      this.setState({ feedbacksIdsSelected: feedbacksIdsSelected })
    })
  }

  /**
   * Download to xlsx with the information of shipments selected by user
   * @returns 
   */
  downloadExcel = () => {
    if (this.state.session.role === Roles.ROLE_USER.Name) {
      this.downloadFeedbacksXLS()
      return
    }

    if (this.state.session.role === Roles.ROLE_ADMIN.Name || this.state.session.role === Roles.ROLE_SUPERVISOR.Name) {
      this.downloadFeedbacksOfBillableXLS()
      return
    }
  }

  downloadFeedbacksXLS = () => {
    this.setState({ isLoading: true })
    InboxCli.DownloadFeedbacksXLS(this.state.feedbacksIdsSelected, "feedbacks.xls").then((error) => {
      if (error) this.setState({ message: error.substring(error.indexOf(' ')), severity: "error" })
      else this.setState({ message: null })
    })
    this.setState({ isLoading: false })
  }

  downloadFeedbacksOfBillableXLS = () => {
    this.setState({ isLoading: true })
    InboxCli.DownloadFeedbacksOfBillableXLS(this.state.feedbacksIdsSelected, "feedbacks.xls").then((error) => {
      if (error) this.setState({ message: error.substring(error.indexOf(' ')), severity: "error" })
      else this.setState({ message: null })
    })
    this.setState({ isLoading: false })
  }

  // Donwload in xls format the data which is contained in feedback table
  downloadReport = () => {
    if (this.state.session.role === Roles.ROLE_USER.Name) {
      this.downloadFeedbackReport()
      return
    }

    if (this.state.session.role === Roles.ROLE_ADMIN.Name || this.state.session.role === Roles.ROLE_SUPERVISOR.Name) {
      this.downloadFeedbackReportOfBillable()
      return
    }
  }

  downloadFeedbackReport = () => {
    this.setState({ isLoading: true })
    ReportCli.DownloadFeedbackReport(true,
      this.state.filters.showStates,
      this.state.filters.showProofs,
      this.state.filters.showCerts,
      this.state.filters.showDocuments,
      this.state.filters.showReports,
      this.state.filters.showStampedCopy).then((error) => {
        if (error) {
          this.setState({ message: error.substring(error.indexOf(' ')), severity: "error" })
        } else {
          this.setState({ message: null })
        }
        this.setState({ isLoading: false })
      })
  }

  downloadFeedbackReportOfBillable = () => {
    this.setState({ isLoading: true })
    ReportCli.DownloadFeedbackReportOfBillable(true,
      this.state.filters.showStates,
      this.state.filters.showProofs,
      this.state.filters.showCerts,
      this.state.filters.showDocuments,
      this.state.filters.showReports,
      this.state.filters.showStampedCopy).then((error) => {
        if (error) {
          this.setState({ message: error.substring(error.indexOf(' ')), severity: "error" })
        } else {
          this.setState({ message: null })
        }
        this.setState({ isLoading: false })
      })
  }

  /**
   * Adding/Removing a shipment code to shipment codes selected list when row checkbox is checked/unchecked
   * @param {*} shipmentcode code of the shipment to add/remove
   * @param {*} option CHECKED/UNCHECKED option to determinate if the action to apply is add or remove
   */
  render() {
    //to pick up the language in the name of the item
    const showItems = [{ "id": "showStates", "name": localizer.InboxShowStates },
    { "id": "showProofs", "name": localizer.InboxShowProofs },
    { "id": "showCerts", "name": localizer.InboxShowCerts },
    { "id": "showDocuments", "name": localizer.InboxShowDocuments },
    { "id": "showStampedCopy", "name": localizer.InboxShowStampedCopy },
    ]
    let showItemsSelected = []
    showItems.map((showItem) => (
      this.state.showItemsSelected.find(s => s.id === showItem.id) && (showItemsSelected.push(showItem))
    ));
   
    const buttonMark = this.initializeButtonMark();
    const dateSince = this.state.filters.dateSince ? DateCustom.convertUTCToLocalShort(this.state.filters.dateSince) : ''
    const dateUntil = this.state.filters.dateUntil ? DateCustom.convertUTCToLocalShort(this.state.filters.dateUntil) : ''
    const totalPages = Math.max(this.getMaxPageFromCount() + 1, 1)
    const currentPage = Math.min(this.state.pagesLoaded + 1, totalPages)
   
    return (
      <React.Fragment>
        <Container maxWidth="xl">
          {/* Screen heading. */}
          <ScreenHeading className="typography-generic"
            icon={<i className="fa-solid fa-inbox icon-button-header mr-20 ml-20"></i>}
            title={localizer.InboxTitle + " (" + CurrencyCustom.numberFormatter(this.state.countUnreadFeedbacks) + " " + localizer.InboxUnread + ")"}
            button={<Button className="button-generic secondary-header" variant="contained" style={{ top: "calc(50% - 20px)" }} onClick={this.checkFeedbacksAsReadOrUnread}>{buttonMark}</Button>}
          />

          <GridHeaderFilter container direction="row" justify="center" alignItems="center">            
            <Grid container item md={12} spacing={2}>
              <Grid item md={4}>
                {/* <InputLabel  className='typography-generic p-0' id="demo-mutiple-chip-label">type to show</InputLabel> */}
                <Select className='typography-generic p-0' style={{ borderRadius: 0, height: 35, backgroundColor: 'white' }}
                  fullWidth
                  height="50px"
                  variant="outlined"
                  value={showItemsSelected}
                  multiple
                  onChange={this.handleFieldChange}
                  renderValue={(selected) => selected.map((x) => x.name).join(', ')}
                  MenuProps={{
                    classes: { paper: "max-height-500" },
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left"
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left"
                    },
                    getContentAnchorEl: null
                  }}
                >
                  {showItems.map((showItem) => (
                    <MenuItem key={showItem.id} value={showItem} data-modal={showItem.id} >
                      <Checkbox
                        color="primary"
                        //checked={this.state.showItemsSelected.includes(showItem) ? true : false}
                        checked={showItemsSelected.find(s => s.id === showItem.id) ? true : false}
                        icon={<i className="fa-regular fa-square font-size-25 color-primary"></i>}
                        checkedIcon={<i className="fa-solid fa-square-check font-size-25 color-primary"></i>}
                      />
                      <ListItemText primary={<Typography className="typography-generic">{showItem.name}</Typography>} />
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
              
              {/* <Grid item md={3}>
                <TextFieldStyled className="bg-white" variant='standard' style={{ height: '35px', borderRadius: 0, borderStyle: 'solid', borderWidth: '0.5px', borderColor: '#c2c0c0' }}
                  id="dateSince" name="dateSince" fullWidth
                  onChange={this.onInputchange} type="date"
                  value={dateSince}
                  label={<Typography className="typography-generic mt-5neg">{localizer.Since}</Typography>}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      input: "typography-generic color-gray mr-10 ml-10 mt-12neg"
                    }
                  }}
                />
              </Grid>
              <Grid item md={3}>
                <TextFieldStyled className="bg-white" style={{ height: '35px', borderRadius: 0, borderStyle: 'solid', borderWidth: '0.5px', borderColor: '#c2c0c0' }}
                  id="dateUntil" name="dateUntil" onChange={this.onInputchange} type="date"
                  value={dateUntil} fullWidth
                  label={<Typography className="typography-generic mt-5neg">{localizer.Until}</Typography>}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      input: "typography-generic color-gray mr-10 ml-10 mt-12neg"
                    }
                  }}
                />
              </Grid>
              <Grid item md={2}>
                <TextFieldStyled id="shipmentCode" onChange={this.onInputchange} label={<Typography className="typography-generic">{localizer.Shipment}</Typography>}
                  name="shipmentCode" variant="outlined" value={this.state.filters.shipmentCode ? this.state.filters.shipmentCode : ""}
                  fullWidth
                  InputProps={{
                    classes: {
                      input: "typography-generic width-120 textinline "
                    }
                  }}
                />
              </Grid>*/}
            </Grid>
           
          </GridHeaderFilter>

          <Grid container direction="row" justify="center" alignItems="center">
            <Grid container justify="flex-start" alignitems="flex-start">

              <Grid item md={6}>
                {/* {localizer.TotalShipments}:&nbsp;<b>{this.state.totalShipments}</b> &nbsp;&nbsp;{localizer.TotalDisplayed}:&nbsp;<b>{this.state.feedbacks.length}</b>&nbsp;&nbsp;{localizer.TotalSelected}:&nbsp;<b>{this.state.feedbacksIdsSelected.length}</b> */}
                {localizer.Total || "Total"}:&nbsp;<b>{CurrencyCustom.numberFormatter(this.state.totalFeedbacks)}</b> &nbsp;&nbsp;{localizer.TotalDisplayed}:&nbsp;<b>{CurrencyCustom.numberFormatter(this.state.feedbacks.length)}</b>&nbsp;&nbsp;{localizer.TotalSelected}:&nbsp;<b>{CurrencyCustom.numberFormatter(this.state.feedbacksIdsSelected.length)}</b>
              </Grid>
              <Grid item md={6} className="text-align-right">
                {/* <Button className="button-generic downloadTable" variant="contained" disabled={disabledbuttondownload} onClick={this.downloadExcel} startIcon={<i className="fa-solid fa-file-excel"></i>}>
                  {localizer.OutboxDownloadExcel}
                </Button> */}
                <Button className="button-generic downloadTable" variant="contained" onClick={this.downloadReport} startIcon={<i className="fa-solid fa-file-excel"></i>}>
                  {localizer.OutboxDownloadExcel}
                </Button>
              </Grid>
              
            </Grid>

            <TableContainer component={Paper}>
              <TableStyled aria-label="collapsible table">
                <TableHead>
                  <TableRowHeaderStyled>
                    <TableCellStyled align="center">
                      <Checkbox
                        checked={this.state.checkedAll}
                        onChange={this.onChangeSelectAll}
                        name="checkedAll"
                        color="primary"
                        icon={<i className="fa-regular fa-square font-size-25 color-primary"></i>}
                        checkedIcon={<i className="fa-solid fa-square-check font-size-25 color-primary"></i>}
                      />
                    </TableCellStyled>
                    <TableCellStyled />
                    <TableCellStyled className="typography-generic tablerow-header" align="center">{localizer.InboxType}</TableCellStyled>
                    <TableCellStyled className="typography-generic tablerow-header" align="center">{localizer.Reference}</TableCellStyled>
                    <TableCellStyled className="typography-generic tablerow-header" align="center">{localizer.InboxShipment} </TableCellStyled>
                    <TableCellStyled className="typography-generic tablerow-header" align="center">{localizer.Addressee} </TableCellStyled>
                    <TableCellStyled className="typography-generic tablerow-header" align="center">{localizer.InboxInformation}</TableCellStyled>
                    <TableCellStyled className="typography-generic tablerow-header" align="center">{localizer.InboxRecordedTime}</TableCellStyled>
                    {/* <TableCellStyled className="typography-generic tablerow-header" align="center">{localizer.InboxUser}</TableCellStyled> */}
                    <TableCellStyled className="typography-generic tablerow-header" align="center">{localizer.InboxDocument}</TableCellStyled>
                  </TableRowHeaderStyled>
                </TableHead>
                <TableBody>
                  {(this.state.feedbacks && this.state.feedbacks.length > 0) ? this.state.feedbacks.map(feedback => (
                    <FeedbackRow key={feedback.returnId} feedback={feedback} products={this.state.products} addOrRemoveSelectedFeedbacks={this.addOrRemoveSelectedFeedbacks} isChecked={this.state.feedbacksIdsSelected.includes(feedback.returnId)} role={this.state.session.role} />
                  ))
                    :
                    <TableRowStyled><TableCellStyled colSpan={10} className="typography-generic tablerow-content font-weight-bold" align="center">{this.state.isLoading ? localizer.WaitingData : localizer.NotFound}</TableCellStyled></TableRowStyled>
                  }
                </TableBody>
              </TableStyled>
            </TableContainer>
          </Grid>
          <Grid container direction="row" justify="flex-end" alignItems="center" style={{ paddingTop: 25 }}>
            <Grid item>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 12, flexWrap: 'nowrap' }}>
                <span className="typography-generic">
                  {localizer.RowsPerPage || "Elementos por página"}:
                </span>
                <Select
                  value={this.state.pageSize}
                  onChange={this.handleChangeRowsPerPage}
                  variant="outlined"
                  className="typography-generic"
                  style={{ height: 35, backgroundColor: 'white', minWidth: 88 }}
                  renderValue={(selected) => <span className="typography-generic">{selected}</span>}
                >
                  {FEEDBACK_PAGE_SIZE_OPTIONS.map((option) => (
                    <MenuItem key={option} value={option}>
                      <Typography className="typography-generic">{option}</Typography>
                    </MenuItem>
                  ))}
                </Select>
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={(event, page) => this.handleChangePage(page - 1)}
                  shape="rounded"
                  color="primary"
                  showFirstButton
                  showLastButton
                  size="small"
                  renderItem={(item) => (
                    <PaginationItem
                      {...item}
                      className="typography-generic"
                      style={item.selected ? { backgroundColor: 'var(--custom-primary-color)', color: '#ffffff' } : null}
                    />
                  )}
                />
              </div>
            </Grid>
          </Grid>
        </Container>

        {/* Get feedbacks error. */}
        <SnackbarCustom message={this.state.feedbackError} severity="error" handleonClose={this.handleonClose} />
       
        {/* Get count unread feedbacks error. */}
        <SnackbarCustom message={this.state.feedbackCountError} severity="error" handleonClose={this.handleonClose} />
    
        {/* Check all as read feedback. */}
        <SnackbarCustom message={this.state.message} severity={this.state.severity} handleonClose={this.handleonClose} />
      
        {/* Check all as read success confirmation. */}
        {/* <SnackbarCustom message={this.state.message} severity="success" handleonClose={this.handleonClose} /> */}
       
        {/* Waiting for service response. */}
        {this.state.isLoading &&
          <Backdrop open={this.state.isLoading} style={{ zIndex: 100 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }

      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/inbox/InboxLayout.js